import React from "react";
import PropTypes from "prop-types";

//
import { Row, Col, Modal } from "react-bootstrap";

//
import InputShow from "../general/InputShow";
import SectionTitle from "../general/SectionTitle";
import btcImage from "../../assets/img/BTC.png";
import ImageBox from "../general/ImageBox";

function AdditionalModal({ show, setShow, data }) {
  return (
    <Modal
      size="lg"
      id="coin-infomation-modal"
      show={show}
      onHide={() => setShow(false)}
    >
      <Modal.Header closeButton className="p-0"></Modal.Header>
      <Modal.Body>
        <ImageBox src={data.image.small} alt="image" />
        <h5>{data.name}</h5>
        <small
          className="description"
          dangerouslySetInnerHTML={{ __html: data.description.en }}
        />
      </Modal.Body>
      <Modal.Footer className="bg-light pt-0">
        <div className="m-0">
          <SectionTitle text="Information data" />
          <Row>
            <Col md={6}>
              <InputShow label="Market Cap" number="-" />
            </Col>
            <Col md={6}>
              <InputShow label="Coingecko rank" number={data.coingecko_rank} />
            </Col>
            <Col md={6}>
              <InputShow
                label="Reddit account active (48h)"
                number={data.community_data.reddit_accounts_active_48h}
              />
            </Col>
            <Col xs={12}>
              <InputShow
                label="Announcement url"
                number={data.links.announcement_url[0]}
              />
            </Col>
            <Col xs={12}>
              <InputShow label="Homepage" link={data.links.homepage[0]} copy/>
            </Col>
            <Col xs={12}>
              <InputShow
                label="Blockchain site"
                link={data.links.blockchain_site[0]}
              />
            </Col>
          </Row>
          <SectionTitle text="Community data" />
          <Row>
            <Col md={6}>
              <InputShow label="Facebook likes" number={data.community_data.facebook_likes} />
            </Col>
            <Col md={6}>
              <InputShow label="Reddit subscriber" number={data.community_data.reddit_subscribers} />
            </Col>
            <Col md={6}>
              <InputShow label="Twitter Follower" number={data.community_data.twitter_followers} />
            </Col>
            <Col md={6}>
              <InputShow label="Reddit account active (48h)" number={data.community_data.reddit_accounts_active_48h} />
            </Col>
            <Col md={6}>
              <InputShow label="Twitter screen name" text={data.links.twitter_screen_name}/>
            </Col>
            <Col md={6}>
              <InputShow label="Reddit avg. post (48h)" number={data.community_data.reddit_average_posts_48h} />
            </Col>
            <Col md={6}>
              <InputShow label="Telegram channel user count" number={data.community_data.telegram_channel_user_count} />
            </Col>
            <Col md={6}>
              <InputShow label="Reddit avg, comment (48h)" number={data.community_data.reddit_average_comments_48h} />
            </Col>
          </Row>
          <SectionTitle text="Developer data" />
          <Row>
            <Col md={6}>
              <InputShow label="Forks" number={data.developer_data.forks} />
            </Col>
            <Col md={6}>
              <InputShow label="Stars" number={data.developer_data.stars} />
            </Col>
            <Col md={6}>
              <InputShow label="Subscriber" number={data.developer_data.subscribers} />
            </Col>
            <Col md={6}>
              <InputShow label="Total Issues" number={data.developer_data.total_issues}/>
            </Col>
            <Col md={6}>
              <InputShow label="Closed Issues" number={data.developer_data.closed_issues} />
            </Col>
            <Col md={6}>
              <InputShow label="Pull Request Contributors" number={data.developer_data.pull_request_contributors} />
            </Col>
            <Col md={6}>
              <InputShow label="Commit Count (4w)" number={data.developer_data.commit_count_4_weeks} />
            </Col>
            <Col md={6}></Col>
          </Row>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

AdditionalModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default AdditionalModal;
